<div class="flex flex-col gap-4">
  <p class="mat-body-2">
    SMS messages will be delivered via your own external SMS bridge. When an
    outbound SMS is created, Principle will fire a
    <strong>message.created</strong> webhook. Your bridge should handle delivery
    and update the message status via the Principle API.
  </p>

  <form
    *prIsManagement
    class="flex flex-col gap-4"
    [formGroup]="managementForm"
  >
    <mat-slide-toggle color="primary" formControlName="enabled">
      Enable Integration
    </mat-slide-toggle>

    <button
      class="self-end"
      mat-flat-button
      color="primary"
      [disabled]="isDisabled$ | async"
      (click)="save()"
    >
      Save
    </button>
  </form>
</div>
